import { ProblemTemplate } from "app/models/problemTemplate";
import { Client } from "app/models/client";
import { Work } from "app/models/work";
import { CallPhotoData } from "app/models/callPhotoData";
import { Report } from "./report";
import { CallMessage } from "app/models/callMessage";

export class Call {

  public id: number;
  public number: number;
  public externalNumber: string;
  public client: Client;
  public description: string;
  public problemTemplate: ProblemTemplate;
  public works: Work[];
  public photos: CallPhotoData[];
  public reports: Report[];
  public messages: CallMessage[];
  public status: Call.Status;
  public cancelStatus: Call.CancelStatus;
  public createdInFSM?: Date;
  public deadline: Date;
  public closed?: Date;
  public author: string;
  public isConfirmed: boolean;
  public isPaused: boolean;
}

export namespace Call {

  export enum Status {

    Opened,
    Closed
  }

  export enum CancelStatus
	{
		NotRequested,
		Requested,
		Successful,
		Unsuccessful
	}
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/call.ts